import {
  ref,
  onMounted,
  defineComponent,
  computed,
  reactive,
} from "@vue/composition-api";
import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import { genericSort, sortIcon } from "@/components/helpers";
import {
  WorkOrderLineItem,
  CompletedWorkOrder,
} from "@/store/modules/billingDashboard";
import { itemRouteBuilder, NamedRts } from "@/router";

export default defineComponent({
  name: "billingDashboard",
  components: {
    LoadingAnimation,
  },

  setup(_props, ctx) {
    const $store = ctx.root.$store;

    const dataLoaded = ref(false);
    const loadingMessage = "Loading billing data...";

    const sortKey = ref<keyof CompletedWorkOrder>("name");
    const sortAsc = ref(true);

    const detailsWorkOrder = reactive({
      name: "",
      id: "",
      total: "0",
      work_order_line_items: [] as WorkOrderLineItem[],
    });

    const localCompletedWorkOrders = ref<CompletedWorkOrder[]>([]);

    const completedWorkOrders = computed(() => {
      let tmpResults = [...localCompletedWorkOrders.value];

      return tmpResults;
    });

    const localSortIcon = (lSortKey: keyof CompletedWorkOrder) => {
      return sortIcon(sortAsc, sortKey, lSortKey);
    };

    const updateSort = (lSortKey: keyof CompletedWorkOrder) => {
      localCompletedWorkOrders.value = genericSort(
        [...localCompletedWorkOrders.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    const apiCompletedWorkOrders = computed(() => {
      return $store.getters.completedWorkOrders as CompletedWorkOrder[];
    });

    const showDetailsWorkOrder = computed(() => {
      if (detailsWorkOrder.work_order_line_items.length > 0) {
        return true;
      } else {
        return false;
      }
    });

    const showRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.workOrderTasks, id);
    };

    const printRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.workOrderPrint, id);
    };

    const loadDetailsWorkOrder = (workOrder: CompletedWorkOrder) => {
      detailsWorkOrder.id = workOrder.id;
      detailsWorkOrder.name = workOrder.name;
      detailsWorkOrder.total = workOrder.total;
      detailsWorkOrder.work_order_line_items = workOrder.work_order_line_items;
    };

    const loadBillingDashboards = () => {
      const jsConn = new JSConn();
      return new Promise((resolve, reject) => {
        $store
          .dispatch("needBillingDashboards", jsConn)
          .then(jsConn => {
            localCompletedWorkOrders.value = [...apiCompletedWorkOrders.value];
            if (localCompletedWorkOrders.value.length > 0) {
              loadDetailsWorkOrder(localCompletedWorkOrders.value[0]);
            } else {
              loadDetailsWorkOrder({
                id: "",
                name: "No details",
                description: "No details",
                start_date: "",
                submitted_date: "",
                total: "0",
                status: "completed",
                client: "",
                client_field: "",
                client_field_id: "",
                acres: "0",
                commodity: "",
                commodity_color: "",
                commodity_id: "",
                work_order_line_items: [] as WorkOrderLineItem[],
              });
            }
            resolve(jsConn);
          })
          .catch(jsConn => {
            reject(jsConn);
          });
      });
    };

    const archivingWOId = ref("");

    const woIsBeingArchived = (workOrder: CompletedWorkOrder) => {
      return archivingWOId.value === workOrder.id;
    };

    const archiveWorkOrder = (workOrder: CompletedWorkOrder) => {
      const jsConn = new JSConn();
      jsConn.formParams = {
        id: workOrder.id,
        status: "archived",
      };

      archivingWOId.value = workOrder.id;
      $store
        .dispatch("updateWorkOrder", jsConn)
        .then(() => {
          archivingWOId.value = "";
          return loadBillingDashboards();
        })
        .then(() => {
          dataLoaded.value = true;
          return Promise.resolve();
        });
    };

    const selectedRowClassObject = (wo: CompletedWorkOrder) => {
      let isRowSelected = false;
      if (wo.id === detailsWorkOrder.id) {
        isRowSelected = true;
      } else {
        isRowSelected = false;
      }

      return {
        "hb-selected-row": isRowSelected,
      };
    };

    onMounted(() => {
      loadBillingDashboards().then(() => {
        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,

      // filter,
      detailsWorkOrder,
      showDetailsWorkOrder,
      loadDetailsWorkOrder,
      selectedRowClassObject,

      updateSort,
      localSortIcon,

      completedWorkOrders,

      showRouteBuilder,
      printRouteBuilder,
      archiveWorkOrder,

      woIsBeingArchived,
    };
  },
});
